let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dAVQn")).then(() => parcelRequire('6o22p'));